<template>
  <div class="sm-account-cont" v-if="userAccount">
    <div class="sm-wrap sm">
      <breadcrumbs-block :crumbs="breadcrumbs" />
    </div>
    <account-upper />
    <account-main />
  </div>
  <sm-spinner v-else :show="!userAccount" />
</template>

<script>
import Upper from '@/views/admin/pages/account/Upper';
import Main from '@/views/admin/pages/account/Main';
import { mapActions, mapGetters } from 'vuex';
import Spinner from '@/components/Spinner';
import Breadcrumbs from '@/components/Breadcrumbs';

export default {
  name: 'account',
  components: {
    'account-upper': Upper,
    'account-main': Main,
    'sm-spinner': Spinner,
    'breadcrumbs-block': Breadcrumbs
  },
  data() {
    return {
      breadcrumbs: [
        {
          link: 'account',
          name: 'admin-account',
          text: 'My Administrator Account',
          current: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      userAccount: 'account/userAccount',
    })
  },
  created() {
    this.getUserAccount();
  },
  methods: {
    ...mapActions({
      getUserAccount: "account/userData"
    })
  }
}
</script>

<style lang="scss">
  .sm-account-cont {
    position: relative;
    padding-top: 44px;

    &::after {
      content: '';
      display: block;
      position: absolute;
      pointer-events: none;
      opacity: 0;
      transition: opacity .2s linear;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255,255,255, .6);
    }

    &.js-popup-show {
      &::after {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }
</style>